<template>
  <div>
    <!-- {{ sortSel }} -->

    <div class="m-headWrap">
      <div style="    width: 500px;" class="colRed u-tip">
        Note: The order report only counts the data after the goods have been
        received, and does not count the data that has not been received.
      </div>
      <div class="m-head">
        <el-tabs v-model="activeChild" @tab-click="handleClick">
          <el-tab-pane v-for="(childItem, j) in childMenu" :name="childItem.value" :key="j">
            <span slot="label" class="fontWeight">{{ childItem.label }}</span>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <ul class="m-sortWarp">
      <li>
        <div class="clear u-sortBtn-list">
          <template v-for="(itemSort, i) in sortData">
            <div :key="i" class="u-sortBtn l" :style="i === 0 ? 'margin-left:0;' : ''">
              <!-- :style="i === 0 ? 'margin-left:0;' : ''" -->

              <u-sortSel :key="i" :id="itemSort.value" :placeholder="itemSort.placeholder" v-model="sortSel[itemSort.value]" :type="itemSort.type" :allData="itemSort.options" :fuzzyQuery="fuzzyQuery"></u-sortSel>
            </div>
          </template>
        </div>

        <div style="width: 100px;" class="exportBtn r marR30" @click="exportImg">
          <!-- <i class="fa">&#xe70a;</i> -->
          Download
        </div>
      </li>
      <li class="clear">
        <span class="l">Statistical indicators：</span>
        <div class="l" style="margin-right: 12px">
          <el-select style="width: 80px" class="font12" v-model="sortSel.indicators" placeholder="Total">
            <el-option class="font12" v-for="item in indicatorsOpt" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="l">
          <el-select style="width: 130px" class="font12" v-model="sortSel.indicators1" placeholder="请选择">
            <el-option v-for="item in indicatorsOpt1" class="font12" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="change l clear" style="margin-left: 90px">
          <span class="l label">Chart type：</span>
          <el-radio-group v-model="type">
            <el-radio class="l" label="bar">
              <span class="checkLabel">Histogram</span>
            </el-radio>
            <el-radio class="l" v-if="sortSel.indicators === 'Total'" label="line">
              <span class="checkLabel">Line chart</span>
            </el-radio>
            <el-radio class="l" label="pie">
              <span class="checkLabel">Pie chart</span>
            </el-radio>
          </el-radio-group>
        </div>
        <ul class="u-stateBtn r clear marR30">
          <template v-for="(item, i) in ['Week', 'Month', 'Quarter', 'Year']">
            <li :key="i" class="l" @click="sortSel.dateState = [1, 2, 3, 4][i]" :class="{ activeState: sortSel.dateState == [1, 2, 3, 4][i] }">
              {{ item }}
            </li>
          </template>
        </ul>
      </li>
    </ul>
    <!-- {{ getJson }} -->
    <div id="exportpdf" ref="exportImg">
      <div v-for="(item, i) in getJson" :key="i">
        <div class="u-line" v-if="i !== 0"></div>
        <div class="m-fromWarp">
          <ul class="u-change clear">
            <li class="title l">
              {{ sortSel.indicators1 }}
            </li>
          </ul>
          <by-charts :deliveryNum="item.deliveryNum" :chartDatas="item.chartDatas" :id="'chart' + i" :type="type" :barWidth="item.barWidth" :activeChild="activeChild"></by-charts>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import byCharts from "./byCharts/byCharts.vue";
import uSortSel from "./uSortSel.vue";
import html2Canvas from "html2canvas";

import {
  fuzzyQuery,
  getCity,
  getContry,
  getAirport,
  getEcharts,
  conversionParameters,
  getStore,
  filterTab,
  getStartAirport
} from "./utils";

export default {
  components: { byCharts, uSortSel },
  data() {
    return {
      activeChild: "1,3,7,20",
      name: "product",

      sortSel: {
        city: {}, //起运城市，
        country: {}, //目的国家
        consignee: {}, //收货人
        consignor: {}, //发货人
        amazon: {}, //AmazonWarehouse
        startAirport: {}, //起运机场
        endAirport: {}, //Destination airport
        orderStatus: 1, //订单状态
        dateState: 1, //日期状态
        indicators: "Total", //第一个Statistical indicators
        indicators1: "Number of products in transit", //第二个Statistical indicators
        deliveryTm: {}, //DeliveryTime
        completeTm: {}
      },

      getJson: [], //图表数据
      sortData: [], // 分类数据
      type: "bar",
      // Statistical indicators
      indicatorsOpt: "",
      indicatorsOpt1: "",
      fuzzyQuery
    };
  },

  created() {
    this.getAjax();
  },
  computed: {
    secendMode() {
      return this.sortSel.indicators1;
    },
    childMenu() {
      // let tab = filterTab();
      // tab.pop();
      return filterTab();
    },
    titleTime() {
      const map = {
        1: "Week",
        2: "Month",
        3: "Quarter",
        4: "Year"
      };
      return map[this.sortSel.dateState];
    },
    titleMode() {
      const map = {
        Total: "总",
        Average: "Average"
      };
      return map[this.sortSel.indicators];
    }
  },

  watch: {
    sortSel: {
      handler(newVal) {
        this.getChartData();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //  获取图表数据  根据接口返回数据需要对它进行处理
    async getChartData() {
      const params = conversionParameters(this);
      let datasChild;
      // debugger;
      // 图表的假数据
      let chartDatas;
      // let chartData = {
      //   title: "Total number of shipments (single)",
      //   sortTitle: [
      //     "2020-02-02 第五周",
      //     "2020-02-02 第六周",
      //     "2020-02-02 第七周"
      //   ],
      //   series: [
      //     {
      //       data: [130000, 9300, 1650],
      //       name: "快递"
      //     }
      //   ]
      // };
      const secondData = () => {
        if (this.sortSel.indicators === "Average") return;

        const allType = ["Cost", "TotalAmount", "rate", "ProductQty"];
        // debugger;
        allType.forEach(k => {
          if (k === "rate") {
            chartDatas[k].secondData = datasChild["ProductQty"];
            chartDatas[k].firstData = chartDatas["rate"].series;
          } else {
            chartDatas[k].secondData = datasChild[k];
            chartDatas[k].firstData = chartDatas[k].series;
          }
        });
      };
      const haveChild = ["1", "20"];

      const getEchart = async () => {
        const res = await getEcharts(
          this.$api03,
          params,
          this.activeChild - 0,
          this
        );
        if (!res) {
          this.getJson = [
            {
              type: "bar",
              barWidth: 20,
              chartDatas: { series: [], sortTitle: [] },
              deliveryNum: { series: [], sortTitle: [] }
            }
          ];
          return false;
        }
        // debugger;
        if (haveChild.includes(this.activeChild)) {
          chartDatas = res.charts;
          datasChild = res.datasChild;
          // console.log("🚀 ~ datasChild", datasChild);
        } else {
          chartDatas = res.charts;
        }
        return true;
      };
      // if (this.activeChild === "1,3,7,20") {
      if (!(await getEchart())) return;
      // }
      if (haveChild.includes(this.activeChild)) {
        secondData();
      }
      // if (this.activeChild === "3") {
      //   await getEchart();
      // }

      // if (this.activeChild === "20") {
      //   await getEchart();
      //   secondData();
      // }
      // debugger;
      // this.getJson[0].deliveryNum = chartData.TotalAmount;
      this.getJson = [
        {
          barWidth: 20,
          chartDatas: chartDatas.ProductQty,
          deliveryNum: chartDatas.ProductQty
        }
      ];
    },

    getOption() {
      this.indicatorsOpt = [
        {
          value: "Total"
        },
        {
          value: "Average"
        }
      ];
      this.indicatorsOpt1 = [
        {
          value: "Number of products in transit"
        },
        {
          value: "Number of products delivered"
        }
      ];
    },
    //获取Filter 条件
    async getSort() {
      let [
        countryOptions,
        cityOptions,
        store,
        airportOptions,
        startAirportOptions
      ] = await Promise.all([
        getContry(this.$api02),
        getCity(this.$api02),
        getStore(this.$api02),
        getAirport(this.$api02),
        getStartAirport(this.$api04)
      ]);
      // console.log("🚀 ~ cityOptions", cityOptions);
      // console.log("🚀 ~ countryOptions", countryOptions);
      // let options = [
      //   {
      //     value: "中国",
      //     label: "中国"
      //   }
      // ];
      let city = {
        placeholder: "Departure city",
        value: "city", //绑定sortSel里的city字段
        width: 185,
        type: "select",
        options: cityOptions
      };
      let country = {
        placeholder: "destination country",
        value: "country",
        width: 185,
        type: "select",
        options: countryOptions
      };
      let consignee = {
        placeholder: "Consignee",
        value: "consignee",
        width: 150,
        type: "select",
        options: cityOptions
      };
      let consignor = {
        placeholder: "Consignor",
        value: "consignor",
        width: 150,
        type: "select",
        options: cityOptions
      };
      let amazon = {
        placeholder: "AmazonWarehouse",
        value: "amazon",
        width: 200,
        type: "select",
        options: store
      };
      let startAirport = {
        placeholder: "Departure airport",
        value: "startAirport",
        width: 150,
        type: "select",
        options: startAirportOptions
      };
      let endAirport = {
        placeholder: "Destination airport",
        value: "endAirport",
        type: "select",
        width: 150,
        options: airportOptions
      };
      let deliveryTm = {
        placeholder: "DeliveryTime",
        type: "date",
        value: "deliveryTm"
      };
      let completeTm = {
        placeholder: "CompletionTime",
        type: "date",
        value: "completeTm"
      };
      // 总览： 起运城市 city， 目的国家 country， 收货人 consignee， 发货人 consignor
      // 快递： 起运城市， 目的国家， 收货人， 发货人
      // 空运： 起运机场 startAirport， Destination airport endAirport， 目的国家 收货人， 发货人
      // FBA： 起运城市， 目的国家，  AmazonWarehouse amazon， 收货人， 发货人
      // specialLine： 起运城市， 目的国家， 收货人， 发货人
      if (this.activeChild === "1,3,7,20") {
        this.sortData = [
          deliveryTm,
          completeTm,
          city,
          country,
          consignee,
          consignor
        ];
      }
      if (this.activeChild === "1") {
        this.sortData = [
          deliveryTm,
          completeTm,
          city,
          country,
          consignee,
          consignor
        ];
      }
      if (this.activeChild === "3") {
        this.sortData = [
          deliveryTm,
          completeTm,
          startAirport,
          endAirport,
          country,
          consignee,
          consignor
        ];
      }
      if (this.activeChild === "20") {
        this.sortData = [
          deliveryTm,
          completeTm,
          city,
          country,
          amazon,
          consignee,
          consignor
        ];
      }
      // if (this.activeChild === "7") {
      //   this.sortData = [deliveryTm, completeTm, consignor, consignee];
      // }
    },
    exportImg() {
      this.getPdf("exportpdf", "Product analysis");
    },
    handleClick() {
      this.getAjax();
    },
    getAjax() {
      this.getChartData(); // 获取图表数据
      this.getOption(); // 获取Statistical indicators
      this.getSort(); //获取分类数据
      this.activeChild !== "1,3,7,20"
        ? (this.showStage = true)
        : (this.showStage = false);
    }
  }
};
</script>

<style lang="scss" scoped>
/*-----------头部标题切换样式------------------*/
// @import "../../../../static/css/userCenterList.css";
.statement {
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
}
.m-head {
  padding-left: 30px;
}
.m-headWrap {
  height: 40px;
  border-bottom: 1px solid #e8e8e8;
}
.m-sortWarp {
  padding: 10px 0 15px 30px;
  background: #f6f6f6;
}
.m-sortWarp li {
  // height: 30px;
  line-height: 30px;
}
.m-fromWarp {
  padding: 20px 0 20px 0;
  position: relative;
}
.u-stateBtn {
  border: 1px solid #d9d9d9;
  height: 28px;
  border-radius: 5px;
  overflow: hidden;
}
.u-stateBtn li {
  width: 59px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  text-align: center;
  background: white;
  border-right: 1px solid #d9d9d9;
  color: #434343;
}
.u-stateBtn li:last-child {
  border-right: 0px;
}
.u-stateBtn .activeState {
  background: #0c5ee5;
  color: #ffffff;
}
.u-sortBtn-list {
  display: inline-block;
  width: 980px;
}
.u-sortBtn {
  margin-right: 13px;
  padding-bottom: 5px;

  /* width: 85px; */

  // width: 820px;
  // display: flex;
  // justify-content: left;
  // flex-wrap: wrap;
  // .bth-item {
  //   margin-right: 13px;
  // }
}

.u-line {
  height: 4px;
  background: #ededed;
}
.u-change {
  position: absolute;
  width: 100%;
  top: 20px;
  z-index: 999;
}
.u-change .title {
  font-size: 14px;
  color: black;
  font-weight: bold;
  margin-left: 30px;
  letter-spacing: 0.5px;
}
.u-change .change {
  font-size: 12px;
  color: black;
  margin-right: 110px;
}
.u-change .label {
  margin-right: 10px;
}
.checkLabel {
  line-height: 16px;
  font-size: 12px;
}
.exportBtn {
  width: 68px;
  height: 28px;
  border: 1px solid #0c5ee4;
  background: #0c5ee4;
  color: #fff;
  border-radius: 25px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  // margin-top: 15px;
}
.u-tip {
  position: absolute;
  right: 45px;
  // line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/productAnalysis.vue